var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 28,
    viewBox: "0 0 130 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 42912"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 22415",
    style: {
      fill: "none"
    },
    d: "M0 0h130v28H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 42911"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30796",
    d: "m45.838 8.555 5.856 14.438h1.765v.374h-7.334v-.374h2.121L43.95 11.66l-4.639 11.333h2.408v.374h-5.008v-.374h2.094L44.77 8.555zm-4.967 9.91H48v.373h-7.129z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30797",
    d: "M55.772 23.366v-.373h2.038V9.221h-2.038v-.374h7.06v.374h-2.038v13.772h2.75a6.86 6.86 0 0 0 2.134-.28 3.271 3.271 0 0 0 1.368-.794 3.206 3.206 0 0 0 .767-1.249 7.216 7.216 0 0 0 .328-1.657h.438v4.353z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30798",
    d: "M70.987 23.366v-.373h2.039V9.221h-2.039v-.374h7.061v.374h-2.039v13.772h2.75a6.863 6.863 0 0 0 2.135-.28 3.369 3.369 0 0 0 1.368-.794 3.216 3.216 0 0 0 .766-1.249 7.161 7.161 0 0 0 .329-1.657h.437v4.353z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30799",
    d: "M86.2 23.366v-.373h2.5V9.209h-2.5v-.374h8.2v.374h-2.724v13.784H94.4v.373z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30800",
    d: "M109.094 8.836V12.8h-.438a4.774 4.774 0 0 0-.548-1.856 3.345 3.345 0 0 0-1.272-1.284 4.323 4.323 0 0 0-2.136-.46h-2.956v13.77H104v.373h-7.289v-.373h2.038V9.2h-2.038v-.376h12.383zm-3.708 9.57a2.412 2.412 0 0 0-.452-1.109 2.117 2.117 0 0 0-.957-.711 4.125 4.125 0 0 0-1.533-.257h-1.491v-.374h1.491a4.448 4.448 0 0 0 1.533-.222 2.12 2.12 0 0 0 .957-.665 2.269 2.269 0 0 0 .452-1.085h.437v4.423z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30801",
    d: "M114.964 23.366v-.373h2.5V9.221h-1.737a3.76 3.76 0 0 0-1.588.3 2.694 2.694 0 0 0-1.053.852 3.873 3.873 0 0 0-.616 1.319 9.55 9.55 0 0 0-.287 1.681h-.452V8.847H126.2v4.529h-.438a7.635 7.635 0 0 0-.287-1.681 4.3 4.3 0 0 0-.63-1.319 2.6 2.6 0 0 0-1.053-.852 3.781 3.781 0 0 0-1.6-.3h-1.738v13.769h2.5v.373z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30802",
    d: "M42.923 5.03h.6V2.894h-.547v-.28h2.928v.28h-.588v2.125c.137-.012.287-.012.424-.024l.4-.035.027.28c-.287.024-.588.047-.917.059s-.643.011-.957.011h-1.37zm1.505 0h.507V2.894H43.9V5.03zm2.518 1.436h-.383V2.194h.383z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30803",
    d: "M54.841 4.762v.28h-2.107v1.424h-.383V5.042H50.23v-.28zm-.684-2.4V4.19h-3.243V2.358h.386V3h2.491v-.642zm-.369.933H51.3v.631h2.491z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30804",
    d: "M59.083 4.178h-.561v.467h.561z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30805",
    d: "M63.516 5.112h.753c.274 0 .561-.012.848-.023s.561-.035.807-.07l.041.28c-.287.035-.588.07-.9.081s-.6.024-.9.024h-1.04V3.77h1.82v-.946h-1.82v-.291h2.2V4.05H63.5v1.062zm3.367 1.354H66.5V2.194h.384z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30806",
    d: "M74.8 5.871h-4.6v-.28h4.61v.28zm-.519-3.28v.28h-.726V4.4h.78v.28h-3.649V4.4h.78V2.871h-.725v-.28zm-2.45 1.8h1.328V2.859h-1.324z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30807",
    d: "M78.021 2.416h2.353v.292H78.4v.6h1.874v.28H78.4v.6h.8c.233 0 .438 0 .63-.011s.37-.012.534-.024.341-.023.519-.046l.042.28c-.179.023-.343.035-.52.046s-.384.024-.6.024-.478.011-.766.011h-1.018zm2.3 2.428a3.111 3.111 0 0 1 .589.058 2.145 2.145 0 0 1 .479.152 1.09 1.09 0 0 1 .328.245.493.493 0 0 1 .123.327V5.8a.516.516 0 0 1-.123.326 1.092 1.092 0 0 1-.328.246 1.845 1.845 0 0 1-.479.151 3.109 3.109 0 0 1-.589.059 3 3 0 0 1-.588-.059 2.455 2.455 0 0 1-.479-.151 1.1 1.1 0 0 1-.329-.246.5.5 0 0 1-.125-.326v-.186a.5.5 0 0 1 .122-.327 1.113 1.113 0 0 1 .329-.245 1.845 1.845 0 0 1 .479-.152 3.051 3.051 0 0 1 .589-.046zm0 1.459a2.671 2.671 0 0 0 .438-.035 1.674 1.674 0 0 0 .37-.106.588.588 0 0 0 .244-.162.281.281 0 0 0 .1-.222v-.14a.26.26 0 0 0-.1-.21.851.851 0 0 0-.246-.163 1.622 1.622 0 0 0-.37-.105 2.752 2.752 0 0 0-.875 0 1.622 1.622 0 0 0-.37.105.588.588 0 0 0-.246.163.293.293 0 0 0-.1.21v.14a.3.3 0 0 0 .1.222 1.168 1.168 0 0 0 .246.163 1.479 1.479 0 0 0 .37.106 2.546 2.546 0 0 0 .437.031zm1.492-1.564h-.383V2.194h.383z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30808",
    d: "M90.842 3.817a.632.632 0 0 1-.138.163c-.082.07-.177.152-.287.234-.041.035-.109.081-.178.128s-.137.093-.219.14-.15.105-.218.152a2.1 2.1 0 0 1-.206.128l-.233-.233.493-.315a4.128 4.128 0 0 0 .452-.339.936.936 0 0 0 .164-.163.475.475 0 0 0 .1-.152.66.66 0 0 0 .054-.152.735.735 0 0 0 .014-.175v-.478H89.5v-.28h2.6v.28h-1.081v.467a.782.782 0 0 0 .014.186.508.508 0 0 0 .055.152.587.587 0 0 0 .123.152l.205.175c.082.058.206.14.342.233a3.825 3.825 0 0 0 .452.269l-.219.233c-.109-.07-.233-.14-.343-.21a3.561 3.561 0 0 1-.3-.2c-.124-.094-.233-.175-.329-.245s-.164-.115-.177-.15zm-.124 2.311h2.805v.292h-3.2V5.007h.377v1.121zm2.3-2.79V2.206h.382v3.058h-.383V3.642h-1.054V3.35h1.054z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30809",
    d: "M101.294 4.377v.28h-2.052v.9h-.383v-.9H96.7v-.28zm-3.543 1.751h2.969v.291h-3.352V5.147h.383zm2.849-2.241h-3.232V2.381h3.232zm-2.846-.28h2.462v-.946h-2.465z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30810",
    d: "M110.818 4.423h-2.257V2.4h.369v.747h1.5V2.4h.369v2.023zm-1.875-.291h1.5V3.42h-1.5zm1.984.7a3.231 3.231 0 0 1 .589.058 1.7 1.7 0 0 1 .479.152 1.1 1.1 0 0 1 .328.245.494.494 0 0 1 .124.327v.175a.5.5 0 0 1-.124.327 1.1 1.1 0 0 1-.328.245 1.845 1.845 0 0 1-.479.152 3.111 3.111 0 0 1-.589.058 3.229 3.229 0 0 1-.588-.058 2.476 2.476 0 0 1-.479-.152 1.1 1.1 0 0 1-.328-.245.5.5 0 0 1-.123-.327v-.175a.526.526 0 0 1 .123-.339 1.1 1.1 0 0 1 .328-.245 1.857 1.857 0 0 1 .479-.151 4.651 4.651 0 0 1 .588-.047zm0 1.471a2.522 2.522 0 0 0 .425-.035 1.665 1.665 0 0 0 .369-.106.968.968 0 0 0 .26-.163.284.284 0 0 0 .1-.222v-.14a.287.287 0 0 0-.1-.222.993.993 0 0 0-.26-.163 1.613 1.613 0 0 0-.369-.105 2.592 2.592 0 0 0-.849 0 1.613 1.613 0 0 0-.369.105.993.993 0 0 0-.26.163.287.287 0 0 0-.1.222v.14a.284.284 0 0 0 .1.222.968.968 0 0 0 .26.163 1.665 1.665 0 0 0 .369.106 2.518 2.518 0 0 0 .424.032zm1.109-3.409v-.7h.383v2.545h-.383v-.712h-.9v-.292h.9v-.549h-.9v-.292z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30811",
    d: "M119.1 4.342c-.123.011-.246.023-.369.023s-.246.023-.37.023-.26.012-.41.024-.287.011-.452.011V5.1h-.383v-.677c-.191.012-.383.012-.6.012h-.7v-.28h1.04c.3 0 .575-.012.821-.012s.479-.023.712-.035c.218-.011.451-.035.684-.046zm-1.724-.491a1.927 1.927 0 0 1-.465-.058 1.194 1.194 0 0 1-.383-.152.875.875 0 0 1-.26-.221.42.42 0 0 1-.1-.28v-.176a.443.443 0 0 1 .1-.28 1.094 1.094 0 0 1 .26-.221 1.515 1.515 0 0 1 .383-.152 2.014 2.014 0 0 1 .465-.059 2.129 2.129 0 0 1 .479.059 1.185 1.185 0 0 1 .383.152.888.888 0 0 1 .26.221.42.42 0 0 1 .1.28v.176a.443.443 0 0 1-.1.28 1.115 1.115 0 0 1-.26.221 1.5 1.5 0 0 1-.383.152 2.232 2.232 0 0 1-.483.058zm0-1.3a1.493 1.493 0 0 0-.328.035 1.226 1.226 0 0 0-.26.093.506.506 0 0 0-.178.14.318.318 0 0 0-.069.175v.117a.313.313 0 0 0 .069.175.487.487 0 0 0 .178.14 1.689 1.689 0 0 0 .26.094 1.41 1.41 0 0 0 .328.035 1.6 1.6 0 0 0 .329-.035 1.859 1.859 0 0 0 .273-.094.394.394 0 0 0 .178-.14.285.285 0 0 0 .069-.175V3a.318.318 0 0 0-.069-.175.5.5 0 0 0-.178-.14 1.381 1.381 0 0 0-.273-.093 1.6 1.6 0 0 0-.333-.036zm-.315 3.571h2.929v.292h-3.312V5.287h.383zm2.422-1.353V2.194h.383v3.327h-.383v-.456h-1.136v-.291z",
    style: {
      fill: "#000416"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30812",
    d: "M24.068 22.188 14.517 0h-1.272L9.1 6.548s2.381-.992 3.188.758L18.2 22.188l-3.174.583v.595h12.49v-.595z",
    style: {
      fill: "#310054"
    },
    transform: "translate(1.901 2.315)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 30813",
    d: "M9.222 13.387a8.34 8.34 0 0 1-1.217.163l-.124.012a4.689 4.689 0 0 0-3.475 1.693c0 .011-.014.011-.014.023a1.281 1.281 0 0 0-.246.7 1.1 1.1 0 0 1-.123.315.326.326 0 0 1-.137-.163.31.31 0 0 1 .055-.28.406.406 0 0 0-.178.28.414.414 0 0 0 .041.175 1.188 1.188 0 0 0 .082.128 1.138 1.138 0 0 1-.315.175c-.369.164-.862.292-1.3.467-.643.257-.424.689-.123.864a.461.461 0 0 1 .164.782c-.219.07-.232.467.041.595-.246.035-.383.315-.218.432.218.047.218.385.068.514-.561.478-.205 1.085.6 1.354l.6-.024c.041.082-.356.444-.438.49a3.619 3.619 0 0 1-.821.409 2.248 2.248 0 0 1-1.081.14A8.237 8.237 0 0 0 0 22.5a3.133 3.133 0 0 0 1.1.642 3.741 3.741 0 0 0 1.436.221 3.112 3.112 0 0 0 .794-.14 4.111 4.111 0 0 0 .753-.327 3.713 3.713 0 0 0 1.108-1.027 4.6 4.6 0 0 0 .6-1.179c.068-.2.123-.4.178-.583.055-.163.082-.3.123-.444a8.319 8.319 0 0 1 .684-1.645 7.332 7.332 0 0 1 2.5-2.615 12.055 12.055 0 0 1 1.888-.98c.342-.152.712-.28 1.081-.42l1.163-.409a8.568 8.568 0 0 0-2.572-.362 7.79 7.79 0 0 0-1.614.155z",
    style: {
      fill: "#310054"
    },
    transform: "translate(1.901 2.315)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.e21e5f12279fdd96cd7bb298615b5c21.svg";
export { ForwardRef as ReactComponent };